import { render, staticRenderFns } from "./soft-comment.vue?vue&type=template&id=b8be454c&scoped=true"
import script from "./soft-comment.vue?vue&type=script&lang=js"
export * from "./soft-comment.vue?vue&type=script&lang=js"
import style0 from "./soft-comment.vue?vue&type=style&index=0&id=b8be454c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be454c",
  null
  
)

export default component.exports